import React from 'react';
import { CheckCircle2Icon, RefreshCwIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const rows = [{
  label: 'Clinical Decision System for Diabetes — 6 Volumes',
  value: '$97 USD'
}, {
  label: 'Professional Consultation Kit — 5 Bonuses',
  value: '$140 USD'
}];
const includes = ['One-time payment', 'No monthly subscription', 'No hidden fees', 'Immediate access after purchase', 'Lifetime access to the current edition'];
export function OfferSection() {
  return <section id="offer" className="bg-white py-14 sm:py-20" aria-labelledby="offer-title" data-id="element-219" data-mp="3sxaw9lsmux3e">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-220" data-mp="3nz9agt3tojo8">
        <SectionHeading eyebrow="Special launch offer" title={<span id="offer-title" data-id="element-222" data-mp="3ex9tg0st5fla">Get the complete system for less than the cost of a textbook.</span>} data-id="element-221" data-mp="3iz4s0xjctevd" />

        <div className="mt-9 overflow-hidden rounded-3xl border-2 border-navy-900" data-id="element-223" data-mp="1arqsq30kcpog">
          <div className="bg-navy-900 px-4 py-3 text-center sm:px-6" data-id="element-224" data-mp="1fj8x711sp8e6">
            <h3 className="text-[11px] font-black uppercase tracking-[0.18em] text-clinic-300 sm:text-xs" data-id="element-225" data-mp="1fkk2546z8m6v">
              Here’s what you get today
            </h3>
          </div>

          <div className="divide-y divide-navy-100 bg-white" data-id="element-226" data-mp="15t7763pvtfwm">
            {rows.map(row => <div key={row.label} className="flex items-start justify-between gap-3 px-4 py-4 sm:px-6" data-id="element-227" data-mp="1tjb986nf97li">
                <span className="text-[14px] font-semibold leading-snug text-navy-800 sm:text-base" data-id="element-228" data-mp="1kid8bx8a5g75">
                  {row.label}
                </span>
                <span className="shrink-0 text-[14px] font-bold text-navy-500 sm:text-base" data-id="element-229" data-mp="1oli4zj5oinnv">
                  {row.value}
                </span>
              </div>)}
            <div className="flex items-center justify-between gap-3 bg-navy-50 px-4 py-4 sm:px-6" data-id="element-230" data-mp="d5thmqoijmmj">
              <span className="text-[13px] font-black uppercase tracking-wide text-navy-900 sm:text-base" data-id="element-231" data-mp="2fqe1puk82qxw">
                Total value
              </span>
              <span className="shrink-0 text-[15px] font-black text-navy-900 line-through sm:text-lg" data-id="element-232" data-mp="260m2gn16h9n3">
                $237 USD
              </span>
            </div>
          </div>

          <div className="bg-clinic-600 px-4 py-7 text-center sm:px-6" data-id="element-233" data-mp="1x0fuths5v3vu">
            <p className="text-[11px] font-black uppercase tracking-[0.16em] text-clinic-100 sm:text-xs" data-id="element-234" data-mp="1x1qub5ekpph5">
              Today, you can get everything for just
            </p>
            <p className="mt-2 text-5xl font-black leading-none tracking-tight text-white sm:text-6xl" data-id="element-235" data-mp="1n31f5ke2aj4l">
              $27
              <span className="ml-2 align-middle text-lg font-black sm:text-2xl" data-id="element-236" data-mp="1i4zxn3waarv8">USD</span>
            </p>
            <p className="mt-3 inline-block rounded-full bg-white px-3 py-1.5 text-[11px] font-black uppercase tracking-wide text-clinic-700 sm:text-sm" data-id="element-237" data-mp="3he6mozs9rfp7">
              Save $210 USD
            </p>
          </div>

          <div className="bg-white p-4 sm:p-6" data-id="element-238" data-mp="3ozsdn52mfmqs">
            <ul className="grid gap-2 sm:grid-cols-2" data-id="element-239" data-mp="3oyhb18kwwl19">
              {includes.map(item => <li key={item} className="flex items-center gap-2" data-id="element-240" data-mp="3trtm0fwo4tbj">
                  <CheckCircle2Icon className="h-4 w-4 shrink-0 text-clinic-600" aria-hidden="true" data-id="element-241" data-mp="2kqutogtyn1b" />
                  <span className="text-[13.5px] font-semibold text-navy-800 sm:text-[15px]" data-id="element-242" data-mp="321fed1f90d8b">
                    {item}
                  </span>
                </li>)}
            </ul>

            <p className="mt-4 flex items-start gap-2 rounded-xl bg-navy-50 px-3 py-2.5 text-[12.5px] font-semibold leading-snug text-navy-700 sm:text-sm" data-id="element-243" data-mp="3b23t5ycguhm9">
              <RefreshCwIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy-600" aria-hidden="true" data-id="element-244" data-mp="qal98agssjno" />
              Currency conversion is automatic — you pay the equivalent of $27 USD in your local
              currency at checkout.
            </p>

            <div className="mt-5" data-id="element-245" data-mp="247xoigdafcx4">
              <CTAButton subtext="Instant download • One-time payment • Lifetime access" data-id="element-246" data-mp="1z79udltrifyo">
                ✅ I want the Clinical Decision System
              </CTAButton>
            </div>

            <div className="mt-5" data-id="element-247" data-mp="287oi0ru7875c">
              <Countdown data-id="element-248" data-mp="286n8wswqtuq9" />
            </div>

            <div className="mt-4" data-id="element-249" data-mp="289rh01dbxam7">
              <ScarcityBar data-id="element-250" data-mp="2n3w1tr1p36k3" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}